// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicB2cV2GetOffersRequest,
  TPublicB2cV2GetOffersModel,
  IMappers,
  TPublicB2cV2GetOffersResponse_,
  TPublicB2cV2GetOffersResponse,
  TPublicB2cV2GetOffersResponse_1,
  TPublicB2cV2GetOffersResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createPublicB2cV2GetOffersModel(parameters: TPublicB2cV2GetOffersRequest): TPublicB2cV2GetOffersModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'mortgage-broker-calculator',
    pathApi: '/b2c/v2/get-offers/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicB2cV2GetOffersOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicB2cV2GetOffersRequest;
}

export async function fetchPublicB2cV2GetOffers<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicB2cV2GetOffersOptions<TResponse200, TResponse400>): Promise<
  TPublicB2cV2GetOffersResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicB2cV2GetOffersModel(parameters),
    config,
  )) as FetchResponse<TPublicB2cV2GetOffersResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TPublicB2cV2GetOffersResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as TPublicB2cV2GetOffersResponseError, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TPublicB2cV2GetOffersResponse;
}
